import {
  type Configuration,
  type PopupRequest,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { ENTRA_CONFIG, ENTRA_AUTHORITY, ENTRA_SCOPES } from './constants';

export const msalConfig: Configuration = {
  auth: {
    clientId: ENTRA_CONFIG.clientId,
    authority: ENTRA_AUTHORITY,
    redirectUri: window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error('[MSAL]', message);
        }
      },
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: ENTRA_SCOPES,
};

export const msalInstance = new PublicClientApplication(msalConfig);

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  isPlatformAdmin: boolean;
  tenantMemberships: TenantMembership[];
}

export interface TenantMembership {
  tenantId: string;
  region: string;
  role: string;
  companyName: string;
  plan?: string;
  workspaceName?: string;
}
